var React = require('react');

function KotlinLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 20H0V0H20L9.79292 9.85527L20 20Z","fill":"url(#paint0_radial_6229_9903)","key":0}),React.createElement("defs",{"key":1},React.createElement("radialGradient",{"id":"paint0_radial_6229_9903","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"translate(19.3354 0.822178) scale(22.9097)"},[React.createElement("stop",{"offset":"0.00343514","stopColor":"#EF4857","key":0}),React.createElement("stop",{"offset":"0.4689","stopColor":"#D211EC","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#7F52FF","key":2})]))]);
}

KotlinLogoInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = KotlinLogoInline;

KotlinLogoInline.default = KotlinLogoInline;
